import { useNavigate } from 'react-router-dom';
import { Mail, Phone, Clock } from 'lucide-react';

const Footer = () => {
  const navigate = useNavigate();

  return (
    <footer className="bg-gray-900 text-gray-300 py-10 px-4 sm:px-6 lg:px-8" data-testid="site-footer">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-8">
          {/* Brand */}
          <div>
            <h3 className="text-white text-lg font-bold mb-3">mybook.rent</h3>
            <p className="text-sm text-gray-400 leading-relaxed">India&apos;s first peer-to-peer book rental platform. Rent books from your neighbours.</p>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-white font-semibold mb-3">Legal</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <button onClick={() => navigate('/terms')} className="hover:text-white transition-colors" data-testid="footer-terms">
                  Terms &amp; Conditions
                </button>
              </li>
              <li>
                <button onClick={() => navigate('/privacy')} className="hover:text-white transition-colors" data-testid="footer-privacy">
                  Privacy Policy
                </button>
              </li>
              <li>
                <button onClick={() => navigate('/refund')} className="hover:text-white transition-colors" data-testid="footer-refund">
                  Returns &amp; Refunds
                </button>
              </li>
              <li>
                <button onClick={() => navigate('/contact')} className="hover:text-white transition-colors" data-testid="footer-contact">
                  Contact Us
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Us */}
          <div>
            <h4 className="text-white font-semibold mb-3">Contact Us</h4>
            <ul className="space-y-2 text-sm">
              <li className="flex items-center gap-2">
                <Mail className="h-4 w-4 flex-shrink-0" />
                <a href="mailto:support@mybook.rent" className="hover:text-white transition-colors">support@mybook.rent</a>
              </li>
              <li className="flex items-center gap-2">
                <Phone className="h-4 w-4 flex-shrink-0" />
                <a href="https://wa.me/918660785749" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">WhatsApp: +91 86607 85749</a>
              </li>
              <li className="flex items-center gap-2">
                <Clock className="h-4 w-4 flex-shrink-0" />
                <span>Response within 2 business days</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-6 text-center text-sm text-gray-500">
          &copy; {new Date().getFullYear()} BOOKONRENT. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
